export function sortByKey<T>(array: T[], key: keyof T): T[] {
	return array?.slice().sort((a, b) => {
		const valueA = a[key];
		const valueB = b[key];

		if (typeof valueA === 'string' && typeof valueB === 'string') {
			return valueA.localeCompare(valueB);
		}
		if (valueA < valueB) {
			return -1;
		}
		if (valueA > valueB) {
			return 1;
		}
		return 0;
	});
}
